import { render, staticRenderFns } from "./AccidentItem.vue?vue&type=template&id=1a6711db&scoped=true&"
import script from "./AccidentItem.vue?vue&type=script&lang=js&"
export * from "./AccidentItem.vue?vue&type=script&lang=js&"
import style0 from "./AccidentItem.vue?vue&type=style&index=0&id=1a6711db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6711db",
  null
  
)

export default component.exports